import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { EcommerceManagement } from '../modal';

export default function reducer(state: EcommerceManagement = new EcommerceManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.ECOMMERCE_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.ECOMMERCE_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.ECOMMERCE_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
